{
  "errors": {
    "yourRoleDoesNotAllowThisAction": "Peran Anda tidak mengizinkan Anda untuk {action}",
    "yourRoleDoesNotAllowYouToPerformThisAction": "Peran Anda tidak mengizinkan Anda melakukan tindakan ini",
    "mustHaveAtLeast8Characters": "Minimal 8 karakter",
    "mustContainUpperCaseAndLowerCase": "Harus mengandung huruf besar dan huruf kecil",
    "mustContainAtLeastOneLetter": "Harus mengandung setidaknya satu huruf",
    "mustContainAtLeastOneSpecialCharacter": "Harus mengandung setidaknya satu karakter khusus",
    "mustContainAtLeastOneNumber": "Harus mengandung setidaknya satu angka"
  },
  "descriptions": {
    "allPermissionsAndFullControlOverAllAccounts": "Semua izin dan kendali penuh atas semua akun.",
    "godRoleWithLessControl": "Peran GOD dengan kendali lebih terbatas.",
    "allPermissionsAndFullControlOverTheOrganizationAccount": "Semua izin dan kendali penuh atas akun Organisasi.",
    "createEditDeleteAppointmentsWarehousesLoadTypesDocksAndUsersExceptOwners": "Buat/ubah/hapus Janji Temu, Gudang, Jenis Muatan, Dok, dan Pengguna (kecuali Pemilik).",
    "createEditCancelAppointments": "Buat/ubah/batalkan Janji Temu.",
    "editAppointmentStatusTagsAndSubscribers": "Ubah Status, tag, dan pelanggan Janji Temu.",
    "viewOnlyNoCreateOrEditActionsAllowed": "Hanya lihat. Tindakan membuat atau mengubah tidak diizinkan.",
    "carrierAdministrator": "Administrator pengangkut.",
    "carrierUser": "Pengguna pengangkut",
    "baseUserAccount": "Akun pengguna dasar.",
    "warehouseDriverHasLimitedAccessToTheApplication": "Pengemudi gudang, memiliki akses terbatas ke aplikasi."
  }
}
